import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, inject, provideEnvironmentInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import { API_BASE_URL } from '@unity/clients';
import { CLIENT_INTERCEPTORS } from '@unity/lib/unity/clientBase';
import { ApiErrorInterceptor } from '@unity/middleware/api.error.interceptor';
import { ApiTenantInterceptor } from '@unity/middleware/api.tenant.interceptor';
import { AuthRefreshInterceptor } from '@unity/middleware/auth.refresh.interceptor';
import { routes } from '@unity/routes';
import { SessionService } from '@unity/services/session.service';

const jwtModule = JwtModule.forRoot({
  config: {
    tokenGetter: () => inject(SessionService).$token(),
    allowedDomains: ['localhost:4200'],
    disallowedRoutes: ['http://localhost:4200/login'],
  },
});

// TODO: if this becomes annoying, it should be rewritten to walk the dynamic folder
// The keys are currently assumed to be SurveyJS question names (see `form-schema.service.ts`).
export const DYNAMIC_SURVEY_QUESTION_REGISTRY = {
  unityCommunityDropdown: () =>
    import('@unity/dynamic/dropdown-communities-question/dropdown-communities-question.component').then(
      m => m.DropdownCommunitiesQuestionComponent
    ),
  unityVendorDropdown: () =>
    import('@unity/dynamic/dropdown-vendors-question/dropdown-vendors-question.component').then(m => m.DropdownVendorsQuestionComponent),
  unityClientDropdown: () =>
    import('@unity/dynamic/dropdown-clients-question/dropdown-clients-question.component').then(m => m.DropdownClientsQuestionComponent),
};

export const config: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withInterceptorsFromDi() // requested by jwt lib
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes(), withComponentInputBinding()),
    // Though deprecated, this is used by some 3rd-party lib (probably Kendo) so we can't remove it
    provideAnimationsAsync(),
    importProvidersFrom(jwtModule),
    provideEnvironmentInitializer(() => DYNAMIC_SURVEY_QUESTION_REGISTRY),
    { provide: API_BASE_URL, useValue: 'api' },
    { provide: CLIENT_INTERCEPTORS, useClass: ApiErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthRefreshInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ApiTenantInterceptor, multi: true },
  ],
};
